/*
 * Copyright (C) 2013 Spanning Cloud Apps.  All rights reserved.
 */
import './gdprRequestDetails.tpl.html';

/**
 * Module for the exportDetails.
 */
angular
  .module('batch.gdprrequest.details', ['sbsf.enums'])
  /**
   * Controller for the gdprRequestDetails template.
   */
  .controller('GdprRequestDetailsCtrl', [
    '$scope',
    '$rootScope',
    'GdprRequestService',
    'GDPR_RECORD_VERSION_STATE',
    function ($scope, $rootScope, GdprRequestService, GDPR_RECORD_VERSION_STATE) {
      $scope.records = [];
      $scope.allRecordsReceived = false;
      const limit = 50;

      $scope.getBatchDetailsPage = () => {
        $rootScope.showLoadingMask = true;

        let lastRecordSfId = '';
        if ($scope.records.length) {
          lastRecordSfId = $scope.records[$scope.records.length - 1].sfId;
        }
        GdprRequestService.getBatchDetails({ batchId: $scope.batchUtils.currentBatch.batchId, lastRecordSfId, limit })
          .then((records) => {
            if (records.length < limit) {
              $scope.allRecordsReceived = true;
            }
            const formattedRecords = records.map((record) => {
              return {
                sfId: record.sfId,
                count: record.count,
                state: record.state === GDPR_RECORD_VERSION_STATE.SUCCESS ? 'SUCCESS_UPPER_CASE' : 'PARTIAL'
              };
            });
            $scope.records = $scope.records.concat(formattedRecords);
          })
          .finally(() => {
            $rootScope.showLoadingMask = false;
          });
      };

      $scope.getBatchDetailsPage();
    }
  ]);
